import React, { Suspense } from "react";
import "../Registration/Registration.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, Redirect } from "react-router-dom";
import Loading from "../../components/Loading";
import Header from "../../DefaultLayout/Header";
import Footer from "../../DefaultLayout/Footer";
import { connect } from "react-redux";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar";
import { Button } from "reactstrap";

function AlreadySignedIn(props) {
  const { frontLabelsName } = props.label;
  const { isAuthenticated, loading } = props.auth;

  if (!loading && !isAuthenticated) {
    // If user is NOT logged in, redirect to login/register
    return <Redirect to="/access-by-otp" />;
  }

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <Header />
        <DashboardNavbar />
      </Suspense>

      <div className="container mb-5 pt-5">
        <div className="row">
          <div className="main-otp-box">
            <div className="otp-box-rg-new text-center" style={{minHeight:"400px"}}>
              <div className="img-mob text-center">
                <img src="assets/verification.svg" alt="check" />
                <h2 className="mt-3">
                  <strong>
                  {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_you_are_already_signed_in")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_you_are_already_signed_in"
                            )[0]["value"] || "lbl_you_are_already_signed_in"
                          : "lbl_you_are_already_signed_in"
                        : "lbl_you_are_already_signed_in"}
                    
                  </strong>
                </h2>
                <p className="color-set-otp">
                {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_click_below_to_view_your_dashboard")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_click_below_to_view_your_dashboard"
                            )[0]["value"] || "lbl_click_below_to_view_your_dashboard"
                          : "lbl_click_below_to_view_your_dashboard"
                        : "lbl_click_below_to_view_your_dashboard"}
                </p>
              </div>

              <div className="button-set pt-4 d-flex justify-content-center">
                <Link to="/dashboard">
                  <Button className="d-flex align-items-center justify-content-center">
                  {frontLabelsName
                        ? frontLabelsName.filter((e) => e.key == "lbl_go_to_dashboard")
                            .length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_go_to_dashboard"
                            )[0]["value"] || "lbl_go_to_dashboard"
                          : "lbl_go_to_dashboard"
                        : "lbl_go_to_dashboard"}
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  label: state.language,
  auth: state.auth,
});

export default connect(mapStateToProps, {})(AlreadySignedIn);
